import React from "react";

///////////////// Users /////////////
export const userColumns = [
  {
    field: "user",
    headerName: "User",
    width: 200,
    renderCell: (row) => {
      if (!row) return null;
      return (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <img
            src={row.img || "https://i.ibb.co/MBtjqXQ/no-avatar.gif"}
            alt={row.username || "avatar"}
            style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover", border: "1px solid #ebebeb" }}
            onError={(e) => { e.target.src = "https://i.ibb.co/MBtjqXQ/no-avatar.gif"; }}
          />
          <div>
            <div style={{ fontSize: 13, fontWeight: 500, color: "#0a0a0a" }}>{row.username || "—"}</div>
            <div style={{ fontSize: 11, color: "#a3a3a3" }}>{row.email || "—"}</div>
          </div>
        </div>
      );
    },
  },
  { field: "email", headerName: "Email", width: 220 },
  { field: "city", headerName: "City", width: 110 },
  {
    field: "oauthProvider",
    headerName: "Provider",
    width: 140,
    renderCell: (row) => {
      if (!row) return null;
      const p = row.oauthProvider;
      const base = { fontSize: 11.5, fontWeight: 500, padding: "3px 9px", borderRadius: 999, display: "inline-flex", alignItems: "center", gap: 4, border: "1px solid" };
      if (p === "google.com") return <span style={{ ...base, background: "#eff6ff", color: "#1d4ed8", borderColor: "#bfdbfe" }}>Google</span>;
      if (p === "facebook.com") return <span style={{ ...base, background: "#f5f3ff", color: "#6d28d9", borderColor: "#ddd6fe" }}>Facebook</span>;
      return <span style={{ ...base, background: "#f7f7f6", color: "#525252", borderColor: "#ebebeb" }}>Email</span>;
    },
  },
  { field: "phone", headerName: "Phone", width: 150 },
  {
    field: "createdAt",
    headerName: "Joined",
    width: 160,
    valueGetter: ({ row }) =>
      row?.createdAt
        ? new Date(row.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })
        : "—",
  },
];

////////////////////// Cafes //////////////
export const cafeColumns = [
  { field: "name", headerName: "Nom du Cafe / Restaurant", width: 180 },
  { field: "type", headerName: "Type", width: 150 },
  { field: "city", headerName: "City", width: 130 },
  { field: "location", headerName: "Adresse Exacte", width: 200 },
  { field: "phone", headerName: "Telephone", width: 130 },
  {
    field: "createdAt",
    headerName: "Date De Création",
    width: 200,
    valueGetter: ({ row }) =>
      row?.createdAt ? new Date(row.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  },
];

///////////////// Hotels /////////////
export const hotelColumns = [
  { field: "name", headerName: "Nom de l'Hôtel", width: 150 },
  { field: "type", headerName: "Type", width: 100 },
  { field: "city", headerName: "Ville", width: 130 },
  { field: "location", headerName: "Adresse Exacte", width: 200 },
  { field: "phone", headerName: "Telephone", width: 150 },
  {
    field: "createdAt",
    headerName: "Date De Création",
    width: 200,
    valueGetter: ({ row }) =>
      row?.createdAt ? new Date(row.createdAt).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—",
  },
];

///////////////// Events /////////////
export const eventColumns = [
  { field: "_id", headerName: "ID", width: 220 },
  { field: "title", headerName: "Title", width: 250 },
  { field: "type", headerName: "Type", width: 100 },
  { field: "city", headerName: "City", width: 100 },
  { field: "date", headerName: "Date", width: 170 },
];

///////////////// Plans /////////////
export const planColumns = [
  { field: "_id", headerName: "ID", width: 250 },
  { field: "title", headerName: "Title", width: 180 },
  { field: "city", headerName: "City", width: 140 },
  {
    field: "youtubeUrl",
    headerName: "Video",
    width: 200,
    renderCell: (row) => {
      if (!row?.youtubeUrl) return <span style={{ color: "#a3a3a3" }}>—</span>;
      return (
        <a
          href={row.youtubeUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: "#1a73e8", textDecoration: "underline" }}
        >
          Watch The Video
        </a>
      );
    },
  },
  {
    field: "featured",
    headerName: "Featured",
    width: 120,
    renderCell: (row) => {
      if (!row) return <span>—</span>;
      return (
        <span style={{ color: row.featured ? "green" : "gray", fontWeight: 600 }}>
          {row.featured ? "Yes" : "No"}
        </span>
      );
    },
  },
  {
    field: "createdAt",
    headerName: "Created",
    width: 200,
    valueGetter: ({ row }) =>
      row?.createdAt ? new Date(row.createdAt).toLocaleString("en-GB") : "—",
  },
];